import { Injectable } from '@angular/core';

import { BaseSearchService } from '@common/services/base-search.service';

import { ISearchable } from '@interfaces';
import { CampaignsService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class SearchService extends BaseSearchService {
  services: ISearchable[] = [];

  constructor(private campaignsService: CampaignsService) {
    super();
    this.services.push(campaignsService);
  }
}
